import React from "react";
import { Phone, Mail } from "lucide-react";
import { BRAND_TXT } from "../lib/brand";

export const TarjetaConsultoria = () => (
  <a href="tel:+34609467788" data-testid="tarjeta-consultoria"
     className="group mt-6 grid grid-cols-1 md:grid-cols-[minmax(0,2fr)_minmax(0,3fr)] rounded-3xl overflow-hidden bg-[#071a33] text-white shadow-lg transition-transform hover:-translate-y-0.5">
    <img src="/img/archiduque-foto.jpg" alt="Farmacéutico asesorando a una clienta" className="w-full h-52 md:h-full object-cover" />
    <div className="relative p-6 md:p-8 overflow-hidden">
      <div className="absolute -right-16 -bottom-20 h-56 w-56 rounded-full bg-sky-500/20 blur-2xl" />
      <div className="flex items-center gap-3 text-[11px] font-extrabold uppercase tracking-[0.2em] text-sky-300">Consultoría especializada<span className="h-px w-12 bg-sky-400" /></div>
      <div className="font-serif text-2xl md:text-3xl font-bold mt-2">Tu farmacia, más rentable.</div>
      <p className="text-sm text-slate-300 mt-2 max-w-md">Más de 15 años acompañando a oficinas de farmacia en optimización de compras, márgenes y stock.</p>
      <div className="flex items-center gap-4 flex-wrap mt-5">
        <img src="/img/farmanaliza-logo-blanco.png" alt="Farmanaliza" className="h-8 w-auto" />
        <span className="text-xs text-slate-300">{BRAND_TXT}</span>
      </div>
      <div className="relative flex items-center gap-3 flex-wrap mt-5">
        <span className="inline-flex items-center gap-2 rounded-full bg-sky-400 text-[#071a33] font-bold px-5 py-2.5 transition-colors group-hover:bg-sky-300" data-testid="tarjeta-consultoria-llamar"><Phone size={16} /> Llamar a Pedro</span>
        <span onClick={(e) => { e.preventDefault(); window.location.href = "mailto:pedro@archiduquecarlos.com"; }} role="link" tabIndex={0}
              className="inline-flex items-center gap-1.5 text-sm text-sky-200 hover:text-white underline-offset-4 hover:underline" data-testid="tarjeta-consultoria-email"><Mail size={14} /> pedro@archiduquecarlos.com</span>
      </div>
    </div>
  </a>
);
